import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/gei/auxiliaries/typologies/list`)
    },
    listAll(data) {
        return axios.get(`/gei/auxiliaries/typologies/list/all`, { params: data })
    },
    find(id) {
        return axios.get(`/gei/auxiliaries/typologies/find/${id}`)
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/typologies/create`, data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/typologies/update`, data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/typologies/delete/${id}`)
    }
}